import * as types from '../types';
import scoring from '../modules/scoring';

function history(state = {
  history: [],
  isFetching: false,
  hasFetched: false,
  reportURL: '',
}, action) {
  switch (action.type) {
  case types.ADD_HISTORY:
    {
      const newState = { ...state };
      const score = scoring.getTotalScore(action.text,
          action.results.result,
          action.results.confidence);

      const scoreByWord = scoring.getScoreByWord(action.text, action.results.result, score, action.results.confidence);

      const historyPackage = {
        source: action.text,
        language: action.language,
        result: action.results,
        score,
        scoreByWord,
      };

      newState.history.push(historyPackage);
      return { ...newState };
    }
  case types.HISTORY_REPORT_REQUEST:
    {
      return { ...state,
          isFetching: true,
          hasFetched: false,
          reportURL: '',
        };
    }
  case types.HISTORY_REPORT_SUCCESS:
    {
      return { ...state,
          isFetching: false,
          hasFetched: true,
          reportURL: URL.createObjectURL(action.response),
        };
    }
  case types.HISTORY_REPORT_FAILURE:
    {
      return { ...state,
          isFetching: false,
          hasFetched: false,
          reportURL: '',
        };
    }
  default:
    return state;
  }
}

export default history;



// WEBPACK FOOTER //
// ./src/reducers/history.js